export default __webpack_public_path__ + "b9fbb57c6d1234d1a9772431656d8e14.svg";